<div class="py-40 px-16">
  <div class="flex flex-col gap-16 sm:flex-row items-center justify-center">
    <h2
      class="h4"
    >
      <span>
        Follow Us:
      </span>
    </h2>
    <ul>
      <li>
        <app-social-links
          [links]="socialLinks"
          [isBlack]="false"
        >
        </app-social-links>
      </li>
    </ul>
  </div>
<div>
